(function () {
    'use strict';

    angular.module('swif.interventions')
    .controller('TransferModalController', TransferModalController);


    function TransferModalController ($scope, $q, swif, swifOpenbaseSiteService) {
        'ngInject';
        $scope.old_model = angular.copy($scope.model);
        $scope.user = swif.user.getAuthenticatedUserData();
        var lastAssignedServiceId = $scope.model.service_id[0];
        $scope.model.service_id = false;
        $scope.allFollowers = [];
        $scope.followersCached = false;
        $scope.srvManager = false;
        $scope.filters = {
            users: getUsersFilter(),
            department: {fields: ['name', 'complete_name', 'manager_id']},
            addresses: getAddressesFilter(),
            template: {fields: []}  // retrieve all fields
        };
        swif.data.addFilter($scope.filters.template, 'create_uid', '=', $scope.user.id);
        _.defaults($scope.model, {
            user_ids: []
        });

        function setFilterByAssignableServices(filter, request_field, inter_field) {
            if ($scope.model._type === 'intervention') {
                return swif.data.addFilter(filter, inter_field, '=', true);
            } else if ($scope.model._type === 'intervention_request') {
                return swif.data.addFilter(filter, request_field, '=', true);
            }
        }

        // Get assignable departments
        /*
            (En Français c'est plus simple) : le service assigné est un des services autorisés des service_ids
            de l'utilisateur.
            Si un des service de l'utilisateurs n'a pas de services autorisés, on affiche tous les services sauf celui de la DI.
        */
        // First get user services to get their partners
        var authorizedServicesFilter = {};
        // Old behaviour, before Taïga ticket = 4293
        // swif.data.addFilter(authorizedServicesFilter, 'id', 'in', swif.user.getAuthenticatedUserData().service_ids);
        swif.data.addFilter(authorizedServicesFilter, 'id', '=', swif.user.getAuthenticatedUserData().service_id[0]);
        swif.collection.createOrUpdate(
            'transfert_authorized_services',
            'department',
            authorizedServicesFilter
        ).then(function (collection) {
            var partnerIds = collection.items.map(service => service.partner_id[0])

            // Now we get all of these partners to get their own services
            var partnerFilter = {};
            swif.data.addFilter(partnerFilter, 'id', 'in', partnerIds);
            swif.collection.createOrUpdate(
                'partners_authorized_services',
                'partner',
                partnerFilter
            ).then(function (partnersCollection) {

                // Then we add to the array those technical services link to the partner's assigned service and only this one
                // EXCEPT if this partner has no authorized services,
                // in this case we show ALL services
                let showAllServices = false;
                let serviceIds = [];
                if (partnersCollection.items[0].technical_service_ids.length) {
                    serviceIds =  partnersCollection.items[0].technical_service_ids
                }

                if (serviceIds.length === 0) {
                    showAllServices = true;
                }

                // set filter for only assignable services depending on the page
                setFilterByAssignableServices(
                    $scope.filters.department,
                    'is_assignable_to_ask',
                    'is_assignable_to_project'
                );

                // Finally, we can filter the corrects services. Tada \o/
                if (showAllServices) {
                    // Show all the services except the DI's one
                    swif.data.addFilter(
                        $scope.filters.department,
                        'id', '!=', lastAssignedServiceId
                    );
                } else {
                    swif.data.addFilter(
                        $scope.filters.department,
                        'id', 'in', serviceIds
                    );
                }

                if($scope.model._type === 'intervention_request') {
                    swif.data.addFilter($scope.filters.department, 'is_assignable_to_ask', '=', 'true');
                }
            });
        });

        $scope.onChangeDepartment = onChangeDepartment;
        $scope.onChangeTemplate = onChangeTemplate;

        $scope.$watch('model.add_followers', watchAddFollowers);
        $scope.$watch('model.add_claimer', watchAddClaimer);
        $scope.$watch('model.user_ids', watchUserIds);

        $scope._siteLoaded = false;
        $scope.loadInterventionSite = function() {
            if (!$scope._siteLoaded && swif.settings.app.modules.openstc_patrimoine && $scope.old_model.site1) {
                swifOpenbaseSiteService.getSiteAddressById($scope.old_model.site1[0]).then(site => {
                    swifOpenbaseSiteService.getSiteAddressFields().map(field => {
                        $scope.old_model[field] = site[field];
                    });
                    $scope._siteLoaded = true;
                });
            }
        };

        function getUsersFilter () {
            var filter = {};

            // set filter for only assignable services depending on the page
            setFilterByAssignableServices(
                filter,
                'service_ids.is_assignable_to_ask',
                'service_ids.is_assignable_to_project'
            );

            if ($scope.model.service_id) {
                swif.data.addFilter(filter, 'service_ids', '=', $scope.model.service_id[0]);
            }
            return filter;
        }

        function getAddressesFilter () {
            var filter = {};
            var u = [];
            if (!_.isEmpty($scope.model.user_ids)) {
                u = _.union(u, $scope.model.user_ids);
            }
            swif.data.addFilter(filter, '|');
            swif.data.addFilter(filter, 'user_id', 'not in', u);
            swif.data.addFilter(filter, 'user_id', '=', false);
            return filter;
        }


        function getAllFollowers () {
            var ret = $q.defer();
            var onError = function (err) {
                ret.reject(err);
            };
            // $scope.allFollowers: cache (fetched only once per modalInstance)
            if (!$scope.followersCached) {
                $scope.followersCached = true;
                var filter = {fields: ['address_ids', 'user_ids']};
                swif.data.addFilter(filter, 'ask_id', '=', $scope.model.id);
                swif.data.get('intervention_request_transfer', undefined, filter)
                .then(function (data) {
                    // addresses2: all address_ids (from previous transfers)
                    // users: all user_ids (from previous transfers)
                    var addresses2 = [];
                    var users = [];
                    // 1st: concatenate data from previous transfers
                    _.forEach(data, function (item) {
                        addresses2 = _.union(addresses2, item.address_ids);
                        users = _.union(users, item.user_ids);
                    });
                    // 2nd: fetch contacts of users and concatenate with addresses2
                    var f = {fields: ['name']};
                    swif.data.addFilter(f, 'user_id', 'in', users);
                    swif.data.get('partner_address', undefined, f).then(function (res) {
                        // addresses3: merge all user_ids contact (from previous transfers)
                        var addresses3 = _.uniq(_.pluck(res, 'id'));
                        // concatenate adresses + users-contact values
                        $scope.allFollowers = _.union(addresses2, addresses3);
                        ret.resolve($scope.allFollowers);
                    }, onError);
                }, onError);
            } else {
                ret.resolve($scope.allFollowers);
            }
            return ret.promise;
        }

        function watchAddFollowers(newV, oldV) {
            if (newV !== oldV) {
                getAllFollowers().then(function (data) {
                    // var data = angular.copy($scope.model);
                    var addresses = [];
                    if (newV) {
                        addresses = _.union($scope.model.address_ids, data);
                    } else {
                        addresses = _.difference($scope.model.address_ids, data);
                    }
                    // apply value ONLY if addresses and model.addresses_ids mismatches
                    if (_.xor(addresses, $scope.model.address_ids)) {
                        $scope.model.address_ids = addresses;
                    }
                    // verifyAndApplyData(data);
                });
            }
        }

        function watchAddClaimer(newV, oldV) {
            if (!_.isUndefined(newV) && newV !== oldV) {
                var claimer = $scope.model.partner_address;
                if (claimer) {
                    if (newV) {
                        $scope.model.address_ids = _.union($scope.model.address_ids, [claimer[0]]);
                    } else {
                        $scope.model.address_ids = _.difference($scope.model.address_ids, [claimer[0]]);
                    }
                }
            }
        }

        function watchUserIds(newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                $scope.filters.addresses = getAddressesFilter();
            }
        }

        function onChangeDepartment (obj) {
            $scope.filters.users = getUsersFilter();
            var users = $scope.model.user_ids || [];
            if ($scope.srvManager) {
                users = _.without(users, $scope.srvManager[0]);
            }
            // update cache of service-manager
            $scope.srvManager = obj.manager_id;
            // add service-manager to users (if there is a manager)
            if ($scope.srvManager) {
                users.push(obj.manager_id[0]);
            }
            $scope.model.user_ids = users;
        }

        function onChangeTemplate (obj) {
            var data = _.omit(obj, 'id');
            _.merge($scope.model, data);
            // verifyAndApplyData(data);
        }

    }

})();
